import i18n from "i18next";
// import path from 'path';
import { reactI18nextModule, initReactI18next } from "react-i18next";
import kr from "./i18n/kr";
import en from "./i18n/en";
import cn from "./i18n/cn";

const resources = {
  kr: kr,
  en: en,
  cn: cn
};

i18n.use(initReactI18next).init(
  {
    ns: ["Common", "ServiceUser", "translation"],
    lng: "en",
    resources,
    fallbackLng: "en",
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true
    }
  },
  (err, t) => {
    // i18n.t('ServiceUser'); // key in moduleA namespace (defined default)
    // i18n.t('translation:ServiceUser'); // key in common namespace
  }
);
export default i18n;
